var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('shepaChart',{attrs:{"type_opration":"count","chartdatas":_vm.ChartDataRegister,"charttype":'line',"group_col":'daily',"XYTitle":'عنوان',"columns":[
        {
          name: 'تعداد کل تراکنش ها',
          field_name: 'cost',
          field_type: 'count',
        },
      ],"title":'تعداد تراکنش های ریالی',"biId":-2}})],1),_c('div',{staticClass:"col-md-6"},[_c('shepaChart',{attrs:{"type_opration":"sum","chartdatas":_vm.ChartDataRegister,"charttype":'line',"group_col":'daily',"XYTitle":'عنوان',"columns":[
        {
          name: 'مبلغ کل ثبت نامی ها',
          field_name: 'cost',
          field_type: 'count',
        },
      ],"title":'مبلغ تراکنش های ریالی',"biId":-2}})],1),_c('div',{staticClass:"col-md-6"},[_c('shepaChart',{attrs:{"type_opration":"count","chartdatas":_vm.ChartDataDollar,"charttype":'line',"group_col":'daily',"XYTitle":'عنوان',"columns":[
        {
          name: 'تعداد کل تراکنش ها',
          field_name: 'cost',
          field_type: 'count',
        },
      ],"title":'تعداد تراکنش های دلاری',"biId":-2}})],1),_c('div',{staticClass:"col-md-6"},[_c('shepaChart',{attrs:{"type_opration":"sum","chartdatas":_vm.ChartDataDollar,"charttype":'line',"group_col":'daily',"XYTitle":'عنوان',"columns":[
        {
          name: 'مبلغ کل ثبت نامی ها',
          field_name: 'cost',
          field_type: 'count',
        },
      ],"title":'مبلغ تراکنش های دلاری',"biId":-2}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }